import { pipe, map } from "rxjs"
import { Contact, ContactType } from "src/app/core/models/common/contact.model"
import { EmailDto } from "src/app/infrastructure/lobby-proxy/DTOs/email.dto"
import { PhoneNumberDto } from "src/app/infrastructure/lobby-proxy/DTOs/phone-number.dto"



export function phoneDtoToContact(source: PhoneNumberDto): Contact {
    return {
        id: source.id,
        description: source.description,
        value: source.value,
        type: ContactType.Phone
    } as Contact
}


export function emailDtoToContact(source: EmailDto): Contact {
    return {
        id: source.id,
        description: source.description,
        value: source.value,
        type: ContactType.Email
    } as Contact
}

export function contactsToDtoChangesContainerContacts(created: Contact[], changed: Contact[], removed: Contact[]) {
    return {
        creates: created.map(r => {
            return {
                description: r.description,
                value: String(r.value)
            }
        }),
        changes: changed.map(r => {
            return {
                id: r.id,
                description: r.description,
                value: String(r.value)
            }
        }),
        removes: removed.map(r => r.id)
    }
}